define('app/views/ga_helper_view',['app/setup'], function(takhfifan) {
  takhfifan.GAHelperView = Backbone.View.extend({
    initialize: function() {
      takhfifan.eventHub.on('ga:sendPageView', function(data) {
        if(data.commands){
          _.each(data.commands, function(item){
            if(item.param){
              ga(item.command, item.param ,item.options);
            }else{
              ga(item.command, item.options);
            }
          })
        }

        this.sendPageView(data.path, data.title, data.callback);
      }, this);
    },
    sendPageView: function (path, title, callback) {
      //track google analytic page view
      if(window.gaTrackVirtualPage){
        var isCOSteps = _.contains(['address', 'shipping', 'payment', 'login'], path);
        if(path.substr(0, 1) !== "/"){
          path = window.location.pathname.replace(/\/?$/, '/') + "#" + path;
        }
        title =   document.title + " | " + title;
        gaTrackVirtualPage(path, title, callback);
        if(isCOSteps && window.hj){
          hj('vpv', path);
        }
      }
    }
  });

  if(_.isFunction(window.ga)){
    new takhfifan.GAHelperView();
  }
});
